import { tqPageView } from "../../utils/utils";
import DrawerForExamples from "../drawer/DrawerForExamples";
import IllustrativeGrid from "../illustrative-grid/IllustrativeGrid";
import damagePhotoGuide_1 from './../../assets/svg/damage-photo-guide/damage-photo-guide_1.svg'
import damagePhotoGuide_2 from './../../assets/svg/damage-photo-guide/damage-photo-guide_2.svg'
import damagePhotoGuide_3 from './../../assets/svg/damage-photo-guide/damage-photo-guide_3.svg'
import damagePhotoGuide_4 from './../../assets/svg/damage-photo-guide/damage-photo-guide_4.svg'

const exampleItems = [<img src={damagePhotoGuide_1} alt="esempio foto danno 1" key={"foto-danno-1"} />, <img src={damagePhotoGuide_2} alt="esempio foto danno 2" key={"foto-danno-2"} />, <img src={damagePhotoGuide_3} alt="esempio foto danno 3" key={"foto-danno-3"} />, <img src={damagePhotoGuide_4} alt="esempio foto danno 4" key={"foto-danno-4"} />]

const EsempiDannoVeicolo = () => {

    const examplesGrid = <IllustrativeGrid
        items={exampleItems}
    />

    const onOpenHandler = () => {
        tqPageView('cai:raccolta foto:esempi illustrati danno')
    }

    return (
        <>
            <DrawerForExamples
                ctaLabel="Vedi esempi"
                drawerTitleLabel={"Esempi illustrati di foto del danno"}
                drawerContent={examplesGrid}
                onOpenCb={onOpenHandler}
            />
        </>
    )
}

export default EsempiDannoVeicolo